export const EntityType = {
  Dealer: "dealer",
  Transporter: "transporter",
};

export const DealerStrategiesEnum = {
  FixedByZip: 1,
  CostPlus: 2,
  Variable: 3,
  PricingBands: 4,
  NissanCityToCity: 5,
  Residential: 6,
};

export const TransporterStrategiesEnum = {
  Variable: 1,
  NissanCityToCity: 2,
};

export const dealerStrategiesNames = {
  [DealerStrategiesEnum.Variable]: "Variable",
  [DealerStrategiesEnum.FixedByZip]: "Fixed by Zip",
  [DealerStrategiesEnum.PricingBands]: "Pricing Bands",
  [DealerStrategiesEnum.CostPlus]: "Cost plus",
  [DealerStrategiesEnum.NissanCityToCity]: "Nissan City to City",
  [DealerStrategiesEnum.Residential]: "Residential",
};

export const dealerStrategiesOptions = Object.entries(dealerStrategiesNames).map(([value, label]) => ({
  value: Number.parseInt(value, 10),
  label,
}));

export const transporterStrategiesNames = {
  [TransporterStrategiesEnum.Variable]: "Variable",
  [TransporterStrategiesEnum.NissanCityToCity]: "Nissan City to City",
};

export const transporterStrategiesOptions = Object.entries(transporterStrategiesNames).map(([value, label]) => ({
  value: Number.parseInt(value, 10),
  label,
}));

const emptyStrategy = {
  concurrencyStamp: null,
  id: null,
  referenceId: null,
};

export const emptyDealerStrategies = {
  [DealerStrategiesEnum.Variable]: {
    ...emptyStrategy,
    strategyType: DealerStrategiesEnum.Variable,
    margin: 10,
  },
  [DealerStrategiesEnum.PricingBands]: {
    ...emptyStrategy,
    strategyType: DealerStrategiesEnum.PricingBands,
  },
  [DealerStrategiesEnum.FixedByZip]: {
    ...emptyStrategy,
    strategyType: DealerStrategiesEnum.FixedByZip,
    items: [],
    totalCount: 0,
  },
  [DealerStrategiesEnum.CostPlus]: {
    ...emptyStrategy,
    strategyType: DealerStrategiesEnum.CostPlus,
    amount: 100,
  },
  [DealerStrategiesEnum.NissanCityToCity]: {
    ...emptyStrategy,
    strategyType: DealerStrategiesEnum.NissanCityToCity,
  },
  [DealerStrategiesEnum.Residential]: {
    ...emptyStrategy,
    strategyType: DealerStrategiesEnum.Residential,
  },
};

export const emptyTransporterStrategies = {
  [TransporterStrategiesEnum.Variable]: {
    ...emptyStrategy,
    strategyType: TransporterStrategiesEnum.Variable,
  },
  [TransporterStrategiesEnum.NissanCityToCity]: {
    ...emptyStrategy,
    strategyType: TransporterStrategiesEnum.NissanCityToCity,
  },
};

export const fetchDealerStrategyByType = {
  [DealerStrategiesEnum.Variable]: "pricingStrategies/dealerGetStrategyVariable",
  [DealerStrategiesEnum.PricingBands]: "pricingStrategies/dealerGetStrategyPricingBands",
  [DealerStrategiesEnum.FixedByZip]: "pricingStrategies/dealerGetStrategyFixedByZip",
  [DealerStrategiesEnum.CostPlus]: "pricingStrategies/dealerGetStrategyCostPlus",
  [DealerStrategiesEnum.NissanCityToCity]: "pricingStrategies/dealerGetStrategyNissanCityToCity",
  [DealerStrategiesEnum.Residential]: "pricingStrategies/dealerGetStrategyResidential",
};

export const fetchTransporterStrategyByType = {
  [TransporterStrategiesEnum.Variable]: "pricingStrategies/transporterGetVariable",
  [TransporterStrategiesEnum.NissanCityToCity]: "pricingStrategies/transporterGetStrategyNissanCityToCity",
};

export const dealerStrategyInitialParamsByType = {
  [DealerStrategiesEnum.FixedByZip]: {
    page: 1,
    pageSize: 10,
  },
  [DealerStrategiesEnum.PricingBands]: {
    page: 1,
    pageSize: 10,
  },
};

export const transporterStrategyInitialParamsByType = {
  [TransporterStrategiesEnum.Variable]: {
    page: 1,
    pageSize: 10,
  },
};

export const PricingValueTypeEnum = {
  Default: 1,
  Group: 2,
  Dealer: 3,
};

export const FixedZipDirection = {
  OneWay: 1,
  Both: 2,
};
